<template>
	<div>
		<div v-if="hiden" class="mask"></div>
		<div class="details" v-if="hiden">
			<div class="details-1">
				{{ $t('main.ImportQuestionnaire') }}
				<i class="el-icon-close" @click="close"></i>
			</div>
			<ul class="import_box">
				<li class="flex space-between">
					<p>1.{{ $t('main.DownloadToLocal') }}</p>
					<div><el-button class="el-btn" plain @click="downLoad">{{ $t('main.DownloadTemplate') }}</el-button></div>
				</li>
				<li class="flex space-between">
					<p>2.{{$t('main.AutomaticallyGenerateQuestionnaires')}}</p>
					<div>
						<a href="javascript:;" class="file">
							{{ $t('main.ImportQuestionnaire') }}
							<input type="file" name="" id="" @change="importFile" />
						</a>
					</div>
				</li>
			</ul>
		</div>
		<!-- 暂停发布 -->
		<el-dialog
			top="30vh"
			:title="$t('main.PausePublishingPrompt')"
			:visible.sync="suspend"
			width="30%"
			:close-on-click-moda="false"
			>
			<span >
				{{ $t('main.PausePublishingPromptText') }}
			</span>
			<span slot="footer" class="dialog-footer">
				<el-button size="medium"  @click="closesuspend">{{ $t('main.cancel') }}</el-button>
				<el-button size="medium" type="primary" @click="suresuspend">{{ $t('main.ok') }}</el-button>
			</span>
		</el-dialog>

		<!-- 回收站 -->
		<el-dialog
			:title="$t('main.recycleBin')"
			width="800px"
			:visible.sync="celbin" :close-on-click-modal="false">
			<el-table
				height="420"
				ref="multipleTable"
				:data="tableData"
				tooltip-effect="dark"
				style="width: 100%"
				@selection-change="handleSelectionChange"
				>
				<el-table-column type="selection" width="55" align="center">
				</el-table-column>
				<el-table-column
					:label="$t('main.title')"
					align="center"
				>
					<template slot-scope="scope">
						{{ regexHtml(scope.row.wjTitle) }}
					</template>
				</el-table-column>
				<el-table-column
					prop="useNumber"
					:label="$t('main.collectData')"
					width="85"
					align="center"
				>
				</el-table-column>
				<el-table-column
					prop="createTime"
					:label="$t('main.CreationTime')"
					width="160"
					align="center"
				>
				</el-table-column>
				<el-table-column
					prop="modifyTime"
					:label="$t('main.DeleteTime')"
					width="160"
					align="center"
				>
				</el-table-column>
			</el-table>
			<el-pagination
				:current-page="page"
				@size-change="handleSizeChange1"
				:page-size="pageSize2"
				background
				layout="prev, pager, next"
				:total="totals"
				@current-change="handleCurrentChange1"
			>
			</el-pagination>
			
			<span slot="footer" class="dialog-footer">
				<el-button :loading="recoveryLoading" size="small" @click="recovery()">{{$t('main.Restore')}}</el-button>
				<el-button :loading="perDeleteLoading" size="small" type="primary" @click="perDelete()">{{$t('main.delete')}}</el-button>
			</span>
		</el-dialog>

		<div class="w">
			<!-- header -->
			<SecondHead activeIndex="1" textColor="#333" color="#333"></SecondHead>
		</div>
		<div class="page-body" v-show="permissionList.admin1001">
			<div class="my-banner flex align-items justify-content">
				<div class="w">
					<el-row>
						<el-col :span="8">
							<div class="list-card-content flex justify-content column align-items" style="margin: 0px auto" @click="tocreate()">
								<img src="../assets/icon_1.png" alt="" />
								<p>{{ $t('main.CreateABlankQuestionnaire') }}</p>
							</div>
						</el-col>
						<el-col :span="8">
							<div class="list-card-content flex justify-content column align-items" style="margin: 0px auto" @click="toImportQuest">
								<img src="../assets/icon_2.png" alt="" />
								<p>{{ $t('main.ImportQuestionnaire') }}</p>
							</div>
						</el-col>
						<!--<el-col :span="6">
                            <div class="list-card-content flex justify-content column align-items">
                                <img src="../assets/icon_3.png" alt="">
                                <p>复制问卷</p>
                            </div>
                        </el-col>-->
						<el-col :span="8">
							<div class="list-card-content flex justify-content column align-items" style="margin: 0px auto" @click="totemplate()">
								<img src="../assets/icon_4.png" alt="" />
								<p>{{ $t('main.ReferenceTemplate') }}</p>
							</div>
						</el-col>
					</el-row>
				</div>
			</div>

			<div class="w" style="padding-bottom: 40px;">
				<div class="my-title">{{$t('main.MyQuestionnaire')}}</div>
				<div class="function flex align-items space-between">
					<div class="flex">
						<div class="flex align-items justify-content img-btn">
							<img src="../assets/grid_icon_def.png" alt="" class="btn-img" v-show="gridShow == 0" style="margin-right: 15px" @click="switchType(1)" />
							<img src="../assets/grid_icon_sel.png" alt="" class="btn-img" v-show="gridShow == 1" style="margin-right: 15px" />
							<img src="../assets/list_icon_def.png" alt="" class="btn-table" v-show="listShow == 1" @click="switchType(2)" />
							<img src="../assets/list_icon_sel.png" alt="" class="btn-table" v-show="listShow == 0" />
						</div>
						<!--<div style="margin-left: 25px">
                            <el-select placeholder="问卷类别" class="select-input" >

                            </el-select>
                        </div>-->
						<div style="margin-left: 25px">
							<el-select :popper-append-to-body="false" v-model="search1.state" :placeholder="$t('main.QuestionnaireStatus')" class="select-input" @change="search()">
								<el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</div>
						<div style="margin-left: 25px">
							<el-date-picker
								v-model="search1.startTime"
								type="date"
								:placeholder="$t('main.CreationTime')"
								format="yyyy-MM-dd"
								value-format="yyyy-MM-dd"
								:editable="false"
								@change="search()"
							></el-date-picker>
						</div>
						<div style="margin-left: 25px">
							<el-input :placeholder="$t('main.PleaseEnterContent')" class="input-with-select" style="width: 260px" v-model="search1.wjTitle" clearable maxlength="30">
								<el-button slot="append" icon="el-icon-search" @click="search()"></el-button>
							</el-input>
						</div>
					</div>
					<div class="flex align-items d-box" @click="recyclebin()">
						<div class="del"></div>
						<p>{{$t('main.recycleBin')}}</p>
					</div>
				</div>

				<!--表格-->
				<div class="table" v-if="state == 1">
					<el-table :data="mywjlist" style="width: 100%">
						<el-table-column prop="wjTitle" :label="$t('main.title')" align="center">
							<template slot-scope="scope">
								<span style="cursor: pointer; padding: 5px" @click="toedit(scope.row)">{{ $functions.html2string(scope.row.wjTitle) }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="wjTypeName" :label="$t('main.type')" width="160" align="center"></el-table-column>
						<el-table-column prop="state" :label="$t('main.state')" width="160" align="center">
							<template slot-scope="scope">
								<span style="font-size: 14px; color: #e96d08" v-if="scope.row.state == 1">{{ $t('main.Editing') }}</span>
								<span style="font-size: 14px; color: #1daa35" v-if="scope.row.state == 2">{{ $t('main.ConscriptionConcentration') }}</span>
								<span style="font-size: 14px; color: #0080ff" v-if="scope.row.state == 3">{{ $t('main.Ended') }}</span>
								<span style="font-size: 14px; color: #ee3f48" v-if="scope.row.state == 4">{{ $t('main.inReview') }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="useNumber" :label="$t('main.collectData')" width="140" align="center">
							<template slot-scope="scope">
								<span style="color: #0080ff">{{ scope.row.useNumber }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="createTime" :label="$t('main.time')" width="165" align="center"></el-table-column>
						<el-table-column :label="$t('main.operate')" width="290" align="center">
							<template slot-scope="scope" style="position: relative;">
								<div class="flex align-items justify-content">
									<span class="span" @click="toedit(scope.row)">{{$t('main.edit')}}</span>
									<span class="span" @click="previewClick(scope.row.id)">{{$t('main.Preview')}}</span>
									<span class="span" @click="publish(scope.row)">{{$t('main.Release')}}</span>
									<span class="span" @click="useNumber(scope.row)">{{$t('main.data')}}</span>
									<span>
										<el-dropdown  trigger="click" placement="bottom" @command="command => handleCommand(command, scope.row)">
											<span class="el-dropdown-link"  style="cursor: pointer;height: 20px;"><img src="../assets/more_icon.png" alt="" class="more-s"/></span>
											<el-dropdown-menu :append-to-body="false" :ref="`${scope.row.id}mydropdList`" slot="dropdown" class="lang-select-dropdown">
												<!-- <el-dropdown-item command="publish">{{$t('main.PublishProject')}}</el-dropdown-item>
												<el-dropdown-item command="previewClick">{{$t('main.PreviewProject')}}</el-dropdown-item> -->
												<el-dropdown-item command="copyQuestionnaire">{{$t('main.CopyProject')}}</el-dropdown-item>
												<!-- <el-dropdown-item command="exportProject">导出项目</el-dropdown-item> -->
												<el-dropdown-item command="wipeData">{{$t('main.wipeData')}}</el-dropdown-item>
												<el-dropdown-item command="deleProject">{{$t('main.deleteItem')}}</el-dropdown-item>
											</el-dropdown-menu>
										</el-dropdown>
										<div :ref="'hereList'+ scope.row.id"></div>
									</span>
								<div :ref="'hereList'+ scope.row.id"></div>
								</div>
							</template>
						</el-table-column>
					</el-table>
					<!-- <div class="more-box" v-if="tipShow == 1">
						<ul class="flex column align-items">
							<li @click="publish(scope.row)">发布项目</li>
							<li @click="previewClick(scope.row.id)">预览项目</li>
							<li @click="wipeData(scope.row.id)">清空数据</li>
							<li @click="deleProject(scope.row.id)">删除项目</li>
						</ul>
					</div> -->
				</div>

				<!--图层-->
				<div class="grid flex" v-else-if="state == 2">
					<div class="grid-list" v-for="item in mywjlist" :key="item.id">
						<div class="grid-list-img"><img :src="item.pictureAddress" alt="" class="top-img" /></div>
						<div class="flex grid-title space-between">
							<p @click="toedit(item)" :title="item.wjTitle">{{ $functions.html2string(item.wjTitle) }}</p>
							<div class="wq flex align-items justify-content">{{$t('main.questionnaire')}}</div>
						</div>
						<div class="grid-list-bottm flex space-between align-items bottom_top">
							<div>
								<span style="font-size: 12px; color: #e96d08" v-if="item.state == 1">{{$t('main.Editing')}}</span>
								<span style="font-size: 12px; color: #1daa35" v-if="item.state == 2">{{$t('main.ConscriptionConcentration')}}</span>
								<span style="font-size: 12px; color: #0080ff" v-if="item.state == 3">{{$t('main.Ended')}}</span>
								<span style="font-size: 12px; color: #ee3f48" v-if="item.state == 4">{{$t('main.inReview')}}</span>
							</div>
							<div style="color: #666; font-size: 12px">{{$t('main.data')}}：{{ item.useNumber }}</div>
							<div style="color: #666; font-size: 12px">{{ item.createTime }}</div>
						</div>
						<div class="bottom-icon">
							<div class="grid-list-bottm flex space-between align-items">
								<div class="flex align-items" style="cursor: pointer">
									<img src="../assets/bj_icon.png" alt="" />
									<span style="color: #0080ff; font-size: 12px; margin-left: 5px" @click="toedit(item)">{{$t('main.edit')}}</span>
								</div>
								<div class="flex align-items" style="cursor: pointer" @click="previewClick(item.id)">
									<img src="../assets/ylsel_icon.png" alt="" />
									<span style="color: #0080ff; font-size: 12px; margin-left: 5px">{{$t('main.Preview')}}</span>
								</div>
								<div class="flex align-items" style="cursor: pointer" @click="publish(item)">
									<img src="../assets/fbsel_icon.png" alt="" />
									<span style="color: #0080ff; font-size: 12px; margin-left: 5px">{{$t('main.Release')}}</span>
								</div>
								<!-- <el-dropdown trigger="click" placement="bottom-end" @command="command => handleCommand(command, item)">
									<span class="el-dropdown-link"><img src="../assets/more_icon.png" alt="" class="more-s" /></span>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item command="publish">发布项目</el-dropdown-item>
										<el-dropdown-item command="previewClick">预览项目</el-dropdown-item>
										<el-dropdown-item command="copyQuestionnaire">复制项目</el-dropdown-item>
									<el-dropdown-item command="exportProject">导出项目</el-dropdown-item> 
										<el-dropdown-item command="wipeData">清空数据</el-dropdown-item>
										<el-dropdown-item command="deleProject">删除项目</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown> -->
								
								<el-dropdown trigger="click" placement="bottom-end" @command="command => handleCommand(command, item)">
									<span class="el-dropdown-link"><img src="../assets/more_icon.png" alt="" class="more-s" /></span>
									<el-dropdown-menu style="white-space: nowrap;" :append-to-body="false" :ref="`${item.id}mydropdCard`"  slot="dropdown">
										<!-- <el-dropdown-item command="publish">{{$t('main.PublishProject')}}</el-dropdown-item>
										<el-dropdown-item command="previewClick">{{$t('main.PreviewProject')}}</el-dropdown-item> -->
										<el-dropdown-item command="copyQuestionnaire">{{$t('main.CopyProject')}}</el-dropdown-item>
										<!-- <el-dropdown-item command="exportProject">导出项目</el-dropdown-item> -->
										<el-dropdown-item command="wipeData">{{$t('main.wipeData')}}</el-dropdown-item>
										<el-dropdown-item command="deleProject">{{$t('main.deleteItem')}}</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
							</div>
						</div>
						<div ref="hereCard"></div>
					</div>
				</div>
				<!--分页-->
				<div class="flex justify-content" style="margin-top: 10px;" v-if="!showEmptyData">
					<el-pagination
						:current-page="pageIndex"
						@size-change="handleSizeChange"
						:page-size="pageSize"
						background
						layout="prev, pager, next"
						:total="total"
						@current-change="handleCurrentChange"
					></el-pagination>
				</div>
				<div class="kong" v-if="showEmptyData">
					<img src="../assets/empty.png" alt="" />
					<p>{{$t('main.ThereIsCurrentlyNoDataAvailable')}}</p>
				</div>
			</div>
		</div>
		<!-- 全部删除输入密码二次确定 -->
		<el-dialog :title="$t('main.PleaseEnterYourLoginPassword')" :visible.sync="passWordVisible" width="30%" :close-on-click-modal="false">
			<span><el-input :placeholder="$t('main.pleaseInputPassword')" v-model="passWordInput" show-password></el-input></span>
			<span slot="footer" class="dialog-footer">
				<el-button size="medium" @click="passWordVisible = false">{{$t('main.cancel2')}}</el-button>
				<el-button size="medium" type="primary" @click="delAllSampleNext()">{{$t('main.ok2')}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import SecondHead from '@/components/SecondHead';
export default {
	name: 'My',
	mounted: function() {
		let type = localStorage.getItem('type');
		if (type == 1) {
			this.state = 2;
			this.listShow = 1;
			this.gridShow = 1;
		} else {
			this.state = 1;
			this.gridShow = 0;
			this.listShow = 0;
		}
		let data = {};
		this.loadData(data);
	},
	components: {
		SecondHead,
	},
	data() {
		return {
			permissionList: {},
			wipeID: '',
			passWordVisible: false,
			passWordInput: '',
			type: 1,
			hiden: false,
			listShow: 0,
			gridShow: 0,
			tipShow: 0,
			createTime: '',
			curStatus: 0,
			state: 1,
			mywjlist: [],
			total: 0,
			pageIndex: 1,
			pageSize: 12,
			statusList: [{ label: this.$t('main.whole'), value: 0 }, { label: this.$t('main.Editing'), value: 1 }, { label: this.$t('main.ConscriptionConcentration'), value: 2 }, { label: this.$t('main.Completed'), value: 3 }],
			gridImgUrl: "url('../assets/grid_icon_def.png')",
			listImgUrl: "url('../assets/list_icon_sel.png')",
			input: '',
			search1: {},
			token: '',
			suspend: false,
			userNumber: 0,
			id: '',
			celbin: false,
			tableData: [],
			page: 1,
			pageSize2: 8,
			totals: 0,
			tableDataLen: 0,
			multipleSelection: [],
			showEmptyData: false,
			recoveryLoading: false,
			perDeleteLoading: false
		};
	},
	methods: {
		language() {
			return window.localStorage.getItem('lang') || this.$defaultLang
		},
		regexHtml(html) {
			let regex = /(<([^>]+)>)/gi;
			let result = html.replace(regex, '');
			return result;
		},
		handleCommand(command, item) {
			if (command == 'publish') {
				this.publish(item);
			} else if (command == 'previewClick') {
				this.previewClick(item.id);
			} else if (command == 'copyQuestionnaire') {
				this.copyQuestionnaire(item.id);
			} else if (command == 'exportProject') {
				this.exportProject(item.id);
			} else if (command == 'wipeData') {
				this.wipeData(item.id);
			} else if (command == 'deleProject') {
				this.deleProject(item.id);
			}
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
			// console.log("输出选中的内容", this.multipleSelection);
		},
		// 删除回收站
		perDelete() {
			let that = this;
			if (this.multipleSelection.length == 0) {
				that.$message.warning(that.$t('main.PleaseSelectAPieceOfData'));
				return false;
			}
			let id = '';
			let ids = [];
			let data = {};
			for (let i = 0; i < this.multipleSelection.length; i++) {
				id = this.multipleSelection[i].id;
				ids.push(this.multipleSelection[i].id);
			}
			this.perDeleteLoading = true
			let params = {
				that: this,
				url: `${this.$config.service.truedelete}`,
				method: 'post',
				data: {
					id: id,
					ids: ids
				},
				cb(res) {
					if (res.code == 0) {
						that.pagefalse(data);
						that.loadData(data);
						that.$message.success(res.message);
					} else {
						that.$message.error(res.message);
					}
				},
				finally() {
					that.perDeleteLoading = false
				}
			};
			this.$util.request(params);
		},
		// 恢复
		recovery() {
			let id = '';
			let ids = [];
			let data = {};

			if (this.multipleSelection.length == 0) {
				this.$message.warning(this.$t('main.PleaseSelectAPieceOfData'));
				return false;
			}

			for (let i = 0; i < this.multipleSelection.length; i++) {
				id = this.multipleSelection[i].id;
				ids.push(this.multipleSelection[i].id);
			}
			this.recoveryLoading = true
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.recovery}`,
				method: 'post',
				data: {
					id: id,
					ids: ids
				},
				cb(res) {
					console.log({ res });
					if (res.code == 0) {
						// console.log("恢复成功", res);
						// that.celbin = false

						that.pagefalse(data);
						that.loadData(data);
					}
				},
				finally() {
					that.recoveryLoading = false
				}
			};
			this.$util.request(params);
		},
		handleCurrentChange1(val) {
			this.page = val;
			this.pagefalse();
		},
		handleSizeChange1(val) {
			this.pageSize2 = val;
			this.pagefalse();
		},
		pagefalse(data) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.pagefalse}?pageIndex=${that.page}&pageSize=${that.pageSize2}`,
				method: 'GET',
				data: data,
				cb(res) {
					if (res.code == 0) {
						that.tableData = res.resultBody.datas;
						that.tableDataLen = res.resultBody.total;
						that.totals = res.resultBody.total;
						// console.log("111", res, that.tableDataLen);
					} else {
						that.tableData = [];
						that.tableDataLen = 0;
						that.totals = 0;
					}
				}
			};
			this.$util.request(params);
		},
		closescelbin() {
			this.celbin = false;
		},
		recyclebin() {
			this.celbin = true;
			this.pagefalse();
		},
		suresuspend() {
			let that = this;
			let data = {};
			let params = {
				that: this,
				url: `${this.$config.service.updastate}`,
				method: 'post',
				data: {
					id: that.id,
					state: 1
				},
				cb(res) {
					if (res.code == 0) {
						that.suspend = false;
						that.loadData(data);
						sessionStorage.setItem('wid', that.id);
						setTimeout(() => {
							that.$router.replace({ path: '/wjedit1' });
						}, 400);
						//  console.log("修改成功");
					}
				}
			};
			this.$util.request(params);
		},
		closesuspend() {
			this.suspend = false;
		},
		suremodify() {
			let that = this;
			let data = {};
			let params = {
				that: this,
				url: `${this.$config.service.updastate}`,
				method: 'post',
				data: {
					id: that.id,
					state: 1
				},
				cb(res) {
					if (res.code == 0) {
						that.loadData(data);
						sessionStorage.setItem('wid', that.id);
						setTimeout(() => {
							that.$router.replace({ path: '/wjedit1' });
						}, 400);
						//  console.log("修改成功");
					}
				}
			};
			this.$util.request(params);
		},
		exportProject(id) {
			// window.open(this.$config.service.exportQuestjions + '?id=' + id + '&Authorization=' + 'Bearer ' + window.localStorage.getItem('token'));

			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.exportTopicStatistics}?id=${id}&state=0&Authorization=Bearer${window.localStorage.getItem('token')}`,
				method: 'Get',
				data: {},
				cb(res) {
					if (res.code == 0) {
						that.popUpPrompt()
					} else {
						that.$message.warning(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		popUpPrompt() {
			this.$notify({
				dangerouslyUseHTMLString: true,
				message: `${this.$t('DataRecycling.DataPreparationInProgress')} 
							<a href="#" class="notify-link" id="my-download-link">
								<span style="color: blue;">${this.$t('DataRecycling.MyDownload')}</span>
							</a> 
							${this.$t('DataRecycling.CanViewProgress')}`
			});
			this.$nextTick(() => {
				const link = document.querySelector('#my-download-link');
				if (link) {
					link.addEventListener('click', (e) => {
						e.preventDefault(); // 阻止默认的链接跳转
						this.$router.push('/MyProject'); // 使用 Vue Router 跳转
					});
				}
			});
		},
		delAllSampleNext() {
			if (this.passWordInput == '') {
				this.$message.warning(this.$t('main.PleaseEnterTheAccountPassword'));
				return false;
			}
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.emptyquestionnaire}`,
				method: 'POST',
				data: {
					// qid: this.id,
					id: this.wipeID,
					password: this.passWordInput
					// source: this.source
				},
				cb(res) {
					console.log('查询全部全部字段对照', res);
					if (res.code == 0) {
						that.pagefalse({});
						that.loadData({});
						that.passWordVisible = false;
						that.passWordInput = '';
						that.$message.success(res.message);
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		wipeData(id) {
			let data = id;
			this.wipeID = id;
			let that = this;
			this.$confirm(this.$t('main.DoYouWantToClearTheCurrentData'), this.$t('main.tip'), {
				confirmButtonText: this.$t('main.ok'),
				cancelButtonText: this.$t('main.cancel'),
				type: 'warning'
			})
				.then(() => {
					that.passWordVisible = true;
					// let params = {
					// 	that: that,
					// 	url: `${that.$config.service.emptyquestionnaire}`,
					// 	data: {
					// 		id: data
					// 	},
					// 	method: 'POST',
					// 	cb(res) {
					// 		if (res.code == 0) {
					// 			let data = {};
					// 			that.loadData(data);
					// 			that.$message.success(res.message);
					// 		} else {
					// 			that.$message.error(res.message);
					// 		}
					// 	}
					// };
					// that.$util.request(params);
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: this.$t('main.EmptyCanceled')
					});
				});
		},
		deleProject(id) {
			//  console.log(id);
			let data = id;
			let that = this;
			// console.log("data", data);
			this.$confirm(this.$t('main.CanBeRestored'), this.$t('main.tip'), {
				confirmButtonText: this.$t('main.ok'),
				cancelButtonText: this.$t('main.cancel'),
				type: 'warning'
			})
				.then(() => {
					let params = {
						that: that,
						url: `${that.$config.service.falsedelete}`,
						data: {
							id: data
						},
						method: 'POST',
						cb(res) {
							if (res.code == 0) {
								let data = {};
								that.loadData(data);
								that.$message.success(res.message);
							} else {
								that.$message.error(res.message);
							}
						}
					};
					that.$util.request(params);
				})
				.catch(() => {
					// this.$message({
					//     type: 'info',
					//     message: '已取消删除'
					// });
				});
		},
		downLoad() {
			// 暂不使用该功能
			window.location.href = 'http://resources.ai-learning.com.cn/%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xls';
			this.hiden = false;
		},
		// 上传文件
		importFile(event) {
			// console.log(event);
			let file = event.target.files[0];
			let formData = new FormData();
			formData.append('multipartFile', file);
			// console.log(formData.get("uploadFile"));
			let that = this;
			that.$axios({
				url: this.$config.service.importQuestionnaire,
				method: 'POST',
				data: formData,
				headers: {
					'Content-Type': 'multipart/form-data',
					Authorization: 'Bearer ' + that.token,
					'Accept-Language': this.language(),
				},
			}).then(res => {
				if (res.data.code == 0) {
					that.$message.success(that.$t('main.ImportWasSuccessful'));
					this.hiden = false;
					that.loadData();
					let wid = res.data.resultBody;
					sessionStorage.setItem('wid', wid);
					setTimeout(() => {
						that.$router.replace({ path: '/questionType' });
					}, 400);
					//that.$router.push({path:"/questionType"})
				} else {
					that.$message.error(that.$t('main.ImportFailed'));
				}
			});
		},
		// 现导入问卷
		toImportQuest() {
			this.$router.push({
				path: '/importQuestion'
			});
		},
		// 原导入问卷
		importWj() {
			this.hiden = true;
		},
		close() {
			this.hiden = false;
		},
		tocreate() {
			sessionStorage.setItem('wid', 0);
			setTimeout(() => {
				this.$router.replace({ path: '/wjedit1', query: { id: 1 } });
			}, 400);
		},
		totemplate() {
			this.$router.replace({ path: '/template' });
		},
		toedit(item) {
			this.userNumber = item.useNumber;
			this.id = item.id;
			// console.log("输出当前的编辑", item);
			if (item.state == 2 && item.useNumber != 0) {
				this.$confirm(this.$t('main.QuestionnaireCollected') + this.userNumber + this.$t('main.PausePublishing'), this.$t('main.ModificationPrompt'), {
					confirmButtonText: this.$t('main.ok'),
					cancelButtonText: this.$t('main.cancel'),
					type: 'warning'
				}).then(() => {
					this.suremodify()   
				}).catch(() => { 
				});
			} else if (item.state == 2 && item.useNumber == 0) {
				this.id = item.id;
				this.suspend = true;
			} else {
				//  console.log("编辑状态", item);
				sessionStorage.setItem('wid', item.id);
				setTimeout(() => {
					this.$router.replace({ path: '/wjedit1', query: { id: 1 } });
				}, 400);
			}
		},
		handleCurrentChange(val) {
			let that = this;
			that.pageIndex = val;
			// let data = this.search1
			this.loadData(this.search1);
		},
		enterImg(index) {
			// console.log("eee");
			this.gridShow = index;
		},
		leaveImg(index) {
			this.gridShow = index;
		},
		enterTable(index) {
			this.listShow = index;
		},
		leaveTable(index) {
			this.listShow = index;
		},
		setMydropdHTML() {
			this.$nextTick(() => {
				this.mywjlist.forEach(item=>{
					if (this.state == 1) {
						this.$refs['hereList' + item.id].appendChild(
							this.$refs[`${item.id}mydropdList`].popperElm
						)
					} else {
						this.$refs.hereCard.appendChild(
							this.$refs[`${item.id}mydropdCard`][0].popperElm
						)
					}
				}) 
			})
		},
		loadData(data) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.mywjlist}?pageIndex=${that.pageIndex}&pageSize=${that.pageSize}`,
				method: 'post',
				data: data,
				cb(res) {
					// console.log({ res });
					if (res.code == 0) {
						that.mywjlist = res.resultBody.datas;
						that.total = res.resultBody.total;
						that.showEmptyData = false;
						that.setMydropdHTML()
					} else {
						that.showEmptyData = true;
						that.mywjlist = res.resultBody.datas;
						that.total = res.resultBody.total;
					}
				}
			};
			this.$util.request(params);
		},
		copyQuestionnaire(id) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.newcopyQuestionnaire}?id=${id}`,
				method: 'post',
				data: {},
				cb(res) {
					if (res.code == 0) {
						that.$message.success(that.$t('main.SuccessfullyCopiedProject'));

						// let wid = res.resultBody.id;
						// sessionStorage.setItem('wid', wid);
						setTimeout(() => {
							that.loadData({});
						}, 0);
					} else {
						that.$message.warning(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		handleSizeChange(val) {
			this.pageSize = val;
			this.loadData();
		},
		switchType(type) {
			localStorage.setItem('type', type);

			if (type == 1) {
				this.state = 2;
				this.listShow = 1;
				this.gridShow = 1;
			} else {
				this.state = 1;
				this.gridShow = 0;
				this.listShow = 0;
			}
			this.setMydropdHTML()
		},
		previewClick(id) {
			//sessionStorage.setItem("wid",id);
			//this.$router.push({path:'/preview'})
			this.$router.push({
				path: '/preview',
				query: { tabPosition: 'computer', id: id , isBank:true }
			});
		},
		publish(item) {
			sessionStorage.setItem('wid', item.id);
			sessionStorage.setItem('wstate', item.state);
			this.$router.push({ path: '/wjmanage/wjpub' });
		},
		search() {
			this.pageIndex = 1;
			this.pageSize = 12;
			this.loadData(this.search1);
		},
		useNumber(item) {
			sessionStorage.setItem('wid', item.id);
			sessionStorage.setItem('wstate', item.state);
			setTimeout(() => {
				this.$router.replace({ path: '/wjstat' });
			}, 400);
		},
		accessPermission() {
			let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
			// console.log(userInfo.permissionList)
			if (userInfo && userInfo.permissionList.length > 0) {
				let arr = userInfo.permissionList;
				let permissionList = {};
				arr.forEach((item, index) => {
					permissionList['admin' + item] = item;
				});
				this.permissionList = permissionList;
			} else {
				this.getUserInfo()
			}
		},
		getUserInfo() {
			console.log()
			let that = this;
			let params = {
				url: this.$config.service.getAllUserBaseInfo,
				data: {},
				that: this,
				cb(res) {
					if (res.code == 0) {
						that.userInfo = res.resultBody;
						if (that.userInfo.usertype == 1) {
							if (that.userInfo.permissionList.length == 0) {
								that.userInfo.permissionList = [
									'1022',
									'1021',
									'1020',
									'1019',
									'1018',
									'1017',
									'1016',
									'1015',
									'1014',
									'1036',
									'1013',
									'1035',
									'1034',
									'1012',
									'1011',
									'1033',
									'1010',
									'1032',
									'1031',
									'1030',
									'1008',
									'1007',
									'1029',
									'1006',
									'1028',
									'1027',
									'1005',
									'1026',
									'1004',
									'1025',
									'1003',
									'1002',
									'1024',
									'1001',
									'1023',
									'1009'
								];
							}
						}
						let arr = that.userInfo.permissionList;
						let permissionList = {};
						arr.forEach((item, index) => {
							permissionList['admin' + item] = item;
						});
						that.permissionList = permissionList;
						window.localStorage.setItem('userInfo', JSON.stringify(that.userInfo));
					}
				}
			};
			that.$util.request(params);
		},
	},
	created() {
		this.token = window.localStorage.getItem('token');
		if (!this.token) {
			this.$router.push({path: '/login'})
		} else {
			this.accessPermission();
		}
	}
};
</script>
<style scoped lang="scss">
/* .lang-select-dropdown {
	position: absolute !important;
	top: none !important;
	left: none !important;
} */
/deep/.el-table .cell {
	overflow: hidden; /*超出部分隐藏*/
	white-space: nowrap; /*不换行*/
	text-overflow: ellipsis; /*超出部分省略号显示*/
}
/deep/.el-table__empty-block {
	display: none !important;
}
/deep/.el-input__inner {
	border: 1px solid #dcdfe6 !important;
}
/deep/.el-input__inner:focus {
	border: 1px solid #0080ff !important;
}
.pageBtn {
	width: 100%;
	height: 60px;
	margin-top: 15px;
	display: flex;
	align-items: center;
	justify-content: space-between;
}
</style>
<style>
.bottom-icon {
	display: none;
}
.grid-list:hover .bottom-icon {
	display: block;
}
.grid-list:hover .bottom_top {
	display: none;
}
.img_icon {
	position: relative;
}
.img_icon:hover .more-box {
	display: block;
}
.page-body {
	height: 100%;
	background: #f5f5f5;
	width: 100%;
}
.my-banner {
	height: 310px;
	width: 100%;
	background: url('../assets/banner-my.png') no-repeat center;
}
.list-card {
	height: 160px;
}
.list-card-content {
	/* width: 210px; */
	height: 160px;
	background: url('../assets/list.png') no-repeat center;
	cursor: pointer;
	margin-left: 40px;
}
.list-card-content p {
	font-size: 16px;
	color: #333;
	margin-top: 20px;
}
.my-title {
	font-size: 18px;
	color: #333;
	margin-top: 40px;
}
.function {
	margin-top: 20px;
}
.d-box {
	cursor: pointer;
}
.d-box .del {
	width: 21px;
	height: 21px;
	background: url('../assets/del_sel_icon.png');
}
.d-box p {
	font-size: 14px;
	margin-left: 12px;
	color: #666;
}
.d-box:hover .del {
	background: url('../assets/del_icon.png');
}
.d-box:hover p {
	color: #0080ff;
}
.img-btn {
	width: 80px;
	height: 40px;
	border: 1px solid #e1e1e1;
	background: #fff;
	cursor: pointer;
}
/* [class*=' el-icon-'],
[class^='el-icon-'] {
	font-size: 18px;
	color: #0080ff;
} */
.select-input {
	width: 110px !important;
	color: #333;
}
.table {
	margin-top: 20px;
	width: 100%;
	background: #fff;
	position: relative;
}
.span {
	color: #0080ff;
	font-size: 14px;
	margin-right: 15px;
	cursor: pointer;
}
.more {
	cursor: pointer;
}
.more-box {
	width: 88px;
	height: 208px;
	background: url('../assets/list_more.png') no-repeat;
	position: absolute;
	right: 0px;
	top: 0;
	display: none;
	z-index: 999;
}
.more-box ul li {
	cursor: pointer;
	font-size: 14px;
	color: #333;
	margin-top: 10px;
}
.t-f-box:hover .more-box {
	display: none;
}
.more-box ul li:hover {
	color: #0080ff;
}
.el-table__body-wrapper {
	overflow: visible;
}
.el-table {
	overflow: visible;
}
/* .el-table .cell {
  overflow: visible;
} */
.grid {
	flex-wrap: wrap;
	margin-top: 20px;
}
.grid-list {
	width: 280px;
	height: 216px;
	background: #fff;
	margin-right: 25px;
	border-radius: 5px;
	margin-bottom: 20px;
	cursor: pointer;
}
.grid-list:nth-child(4n) {
	margin-right: 0px;
}
.grid-list-img {
	height: 120px;
	border-top-right-radius: 5px;
	border-top-left-radius: 5px;
}
.top-img {
	width: 100%;
	height: 100%;
}
.grid-title {
	margin-top: 15px;
	padding: 0 12px;
}
.wq {
	padding: 0 10px;
	height: 22px;
	background: #d6edff;
	color: #0080ff;
	border-radius: 5px;
	font-size: 12px;
	cursor: pointer;
}
.grid-title p {
	font-size: 14px;
	color: #333;
	width: 60%;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}
.grid-list-bottm {
	padding: 0 12px;
	margin-top: 12px;
}
.kong {
	width: 1200px;
	height: 660px;
	background: #fff;
	margin: 0 auto;
}
.kong img {
	width: 250px;
	height: 233px;
	margin-left: 476px;
	margin-top: 100px;
}
.kong p {
	font-size: 20px;
	text-align: center;
	color: #999999;
	font-family: MicrosoftYahei;
	margin-top: 50px;
}
.mask {
	position: fixed;
	left: 0;
	top: 0;
	z-index: 1001;
	width: 100%;
	height: 100%;
	background-color: #000;
	opacity: 0.3;
}
.details {
	/* // 遮罩层内容 */
	position: fixed;
	background: #fff;
	width: 600px;
	/* // height: 240px; */
	overflow: auto;
	opacity: 1;
	z-index: 2001;
	top: 30%; /*偏移*/
	left: 50%;
	margin-left: -300px;
}
.details2 {
	position: fixed;
	background: #fff;
	width: 800px;
	height: 590px;
	overflow: auto;
	opacity: 1;
	z-index: 2001;
	top: 20%; /*偏移*/
	left: 45%;
	margin-left: -300px;
}
.details-1 {
	width: 100%;
	height: 60px;
	line-height: 60px;
	background: #fff;
	position: relative;
	color: #333;
	border-bottom: 1px solid #0080ff;
	font-size: 18px;
	text-align: center;
}
.details-1 i {
	color: #999;
	position: absolute;
	right: 20px;
	top: 34%;
}
.import_box {
	width: 100%;
	min-height: 150px;
	background: #fff;
	margin-top: 20px;
}
.import_box li {
	padding: 0 30px;
	margin-top: 20px;
}
.el-btn {
	font-size: 16px;
	background: #fff;
	border: 1px solid #0080ff;
	color: #0080ff;
}
.file {
	position: relative;
	display: inline-block;
	background: #0080ff;
	border-radius: 4px;
	padding: 9px 21px;
	overflow: hidden;
	color: #fff;
	text-decoration: none;
	text-indent: 0;
	line-height: 20px;
	font-size: 16px;
}
.file input {
	position: absolute;
	font-size: 100px;
	right: 0;
	top: 0;
	opacity: 0;
}
.flex {
	align-items: center;
}
el-input:focus {
	border: 1px solis #0080ff;
}
.el-pagination.is-background{
  text-align: right;
  margin-top: 10px;
}
</style>
